import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Accordion as Accordion$1, AccordionItem as AccordionItem$1, AccordionItemHeading as AccordionItemHeading$1, AccordionItemButton, AccordionItemPanel as AccordionItemPanel$1, AccordionItemState } from 'react-accessible-accordion';
export { AccordionItemButton } from 'react-accessible-accordion';
import { IconArrowUp } from '../icons/generated/ArrowUp.js';
import { IconArrowDown } from '../icons/generated/ArrowDown.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
const Accordion = /*#__PURE__*/styled(Accordion$1).withConfig({
  displayName: "accordion__Accordion",
  componentId: "sc-wzevbp-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
const AccordionItem = /*#__PURE__*/styled(AccordionItem$1).withConfig({
  displayName: "accordion__AccordionItem",
  componentId: "sc-wzevbp-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-block-start: ", ";\n"])), _ref => {
  let {
    theme
  } = _ref;
  return "1px solid ".concat(theme.colors.accents.muted);
});
const StyledAccordionItemHeading = /*#__PURE__*/styled(AccordionItemHeading$1).withConfig({
  displayName: "accordion__StyledAccordionItemHeading",
  componentId: "sc-wzevbp-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: bold;\n\n  font-family: ", ";\n  line-height: 1;\n\n  [dir='rtl'] & {\n    font-family: ", ";\n    line-height: ", ";\n    text-transform: none;\n  }\n\n  color: ", ";\n\n  ", "\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.fontSizes.large;
}, _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.fonts.heading;
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.rtlFonts.heading;
}, _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.rtlLineHeights.heading;
}, _ref6 => {
  let {
    theme
  } = _ref6;
  return theme.colors.text;
}, theme('name', {
  pureGym: "text-transform: uppercase;"
}));
const StyledAccordionItemButton = /*#__PURE__*/styled(AccordionItemButton).withConfig({
  displayName: "accordion__StyledAccordionItemButton",
  componentId: "sc-wzevbp-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  padding: ", ";\n  gap: ", ";\n\n  color: ", ";\n  transition: ", ";\n  cursor: pointer;\n\n  &:hover,\n  &:focus,\n  &:active {\n    color: #fff;\n    background-color: ", ";\n  }\n"])), _ref7 => {
  let {
    theme
  } = _ref7;
  return theme.spacing.baseSpacing;
}, _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.spacing.halfSpacing;
}, _ref9 => {
  let {
    theme
  } = _ref9;
  return theme.colors.text;
}, _ref10 => {
  let {
    theme
  } = _ref10;
  return theme.transitionsMs.default;
}, _ref11 => {
  let {
    theme
  } = _ref11;
  return theme.colors.primary.main;
});
const AccordionItemPanel = /*#__PURE__*/styled(AccordionItemPanel$1).withConfig({
  displayName: "accordion__AccordionItemPanel",
  componentId: "sc-wzevbp-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: ", ";\n"])), _ref12 => {
  let {
    theme
  } = _ref12;
  return theme.spacing.baseSpacing;
});
const AccordionItemHeading = /*#__PURE__*/forwardRef(function AccordionItemHeading(_ref13, ref) {
  let {
    children,
    level = 3,
    ...rest
  } = _ref13;
  return /*#__PURE__*/jsx(StyledAccordionItemHeading, {
    ref: ref,
    "aria-level": level,
    ...rest,
    children: /*#__PURE__*/jsxs(StyledAccordionItemButton, {
      children: [/*#__PURE__*/jsx("span", {
        children: children
      }), /*#__PURE__*/jsx("span", {
        children: /*#__PURE__*/jsx(AccordionItemState, {
          children: _ref14 => {
            let {
              expanded
            } = _ref14;
            return expanded ? /*#__PURE__*/jsx(IconArrowUp, {
              "aria-hidden": true
            }) : /*#__PURE__*/jsx(IconArrowDown, {
              "aria-hidden": true
            });
          }
        })
      })]
    })
  });
});

export { Accordion, AccordionItem, AccordionItemHeading, AccordionItemPanel };
